<template>
    <div>
        <div id="places-page" v-if="!user.global_admin">
            <h1>{{ t('places-access_denied') }}</h1>
        </div>
        <div id="places-page" v-if="user.global_admin">
            <loader v-if="is('loading')"></loader>
            <div class="container-fluid" v-if="is('ready')">
                <div class="row">
                    <div
                        class="d-flex justify-content-between align-items-center flex-column flex-sm-row col-12"
                    >
                        <div class="col col-md-6">
                            <div class="input-group mb-3">
                                <input
                                    v-model="search"
                                    :placeholder="t('places-filter_placeholder')"
                                    :aria-label="t('places-filter_placeholder')"
                                    type="text"
                                    class="form-control"
                                    aria-describedby="cleansearch"
                                />
                                <div class="input-group-append">
                                    <button
                                        @click="search = null"
                                        class="btn btn-outline-secondary"
                                        type="button"
                                        id="cleansearch"
                                    >
                                        <i class="fa fa-eraser"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col mb-3 col-md-4">
                            <router-link
                                class="btn btn-primary col-12"
                                v-bind:to="'/place/form'"
                            >
                                {{ t('places-add_place') }}
                            </router-link>
                        </div>
                    </div>
                </div>
                <div class="row places">
                    <div
                        v-for="place in filterPlaces"
                        class="place"
                        :key="place.id"
                        :class="{ 'opacity-25': place.active === 0 }"
                    >
                        <router-link v-bind:to="'/place/' + place.id">
                            <img
                                :src="place.logo"
                                @error="
                                    $root.errorImage(
                                        $event,
                                        'apple-touch-icon.png',
                                    )
                                "
                            />
                            <span class="name">{{ place.name }}</span>
                        </router-link>
                        <button
                            :class="`btn btn-sm btn-${islogAsPlace(place.id) ? 'success' : 'primary'}`"
                            @click="logAsPlace(place.id)"
                            :disabled="islogAsPlace(place.id)"
                        >
                            {{
                                islogAsPlace(place.id)
                                    ? t('places-selected')
                                    : t('places-view_as')
                            }}
                        </button>
                    </div>

                    <div v-if="filterPlaces.length == 0" class="row places">
                        <h2 class="col">{{ t('places-no_places_found') }}</h2>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import PlacesBase from "./places-base";

export default {
    template: "#places-template",
    extends: PlacesBase,
    props: {
        user: Object,
    },
    data: function () {
        return {
            state: "loading",
            success: true,
        };
    },
    methods: {
        setState: function (state) {
            this.state = state;
        },
        is: function (state) {
            return state === this.state;
        },
        logAsPlace: function (id) {
            this.$store.dispatch("changePlace", id);
            this.filter_selected_place = this.places.find((pl) => pl.id === id);
        },
        islogAsPlace(place_id) {
            let place = this.$store.state.place;
            return place && place.id == place_id;
        },
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
    },
    mounted() {
        this.search = localStorage.getItem("search");
    },
};
</script>
